export const SMS_ENTRY_LABELS = {
  purchase: '購買',
  adjustment: '調整',
  sent: '已發送',
  insufficient: '點數不足',
  failed: '發送失敗',
};

export const SMS_SOURCE_LABELS = {
  otp: '驗證碼',
  notification: '通知',
  birthday_gift: '生日禮',
  anniversary_gift: '週年禮',
  points_expiry: '點數到期',
  tier_downgrade: '會員降等',
  tier_upgrade: '升等禮',
  registration_gift: '註冊禮',
  batch_coupon: '批次發券',
  batch_points: '批次派點',
  chatdesk_transfer: '客服轉派',
  salon: '美髮預約',
  salon_reminder: '美髮提醒',
  reservation: '預約',
  reservation_reminder: '預約提醒',
};

export function smsEntryLabel(type) {
  return SMS_ENTRY_LABELS[type] || type || '';
}

export function smsSourceLabel(source) {
  if (!source) return '';
  return SMS_SOURCE_LABELS[source] || source;
}

export function formatSmsPoints(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '';
  return Number.isInteger(n) ? String(n) : n.toFixed(2);
}
